module.exports = __webpack_public_path__ + "src/img/num.4c25c637.png";